module.exports = "/_next/static/images/CombineData@2x-2d12c21d1edbfef755ff80f2e948b392.png";